import { isCancel } from 'axios';

function isCancelledRequest(response) {
  return isCancel(response);
}

export default isCancelledRequest;
